import { getIdToken } from "./firebase";

export const geminiCall = async (prompt, systemPrompt="", maxTokens=3000) => {
  const headers = { "Content-Type": "application/json" };

  // CRA의 production 빌드에서는 항상 Firebase 인증을 요구한다.
  // 개발 서버는 setupProxy.js의 로컬 Ollama를 사용하므로 인증 없이 호출한다.
  if (process.env.NODE_ENV !== "development") {
    try {
      const idToken = await getIdToken();
      headers.Authorization = `Bearer ${idToken}`;
    } catch {
      throw new Error("AI 일정 생성을 위해 다시 로그인해주세요.");
    }
  }

  const res = await fetch("/api/qwen", {
    method: "POST",
    headers,
    body: JSON.stringify({ prompt, systemPrompt, maxTokens }),
  });
  if (!res.ok) {
    const err = await res.json().catch(()=>({}));
    if (res.status === 503) {
      throw new Error("일시적인 오류입니다. 잠시 후 다시 시도해주세요.");
    }
    if (res.status === 401) {
      throw new Error("로그인 인증이 만료되었습니다. 다시 로그인한 후 시도해주세요.");
    }
    throw new Error(err.error || `서버 오류 (${res.status})`);
  }
  const data = await res.json();
  const text = data.text || "";
  if (!text) throw new Error("빈 응답");
  return text;
};
